import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing }) => ({
  container: {
    width: '50%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: spacing(8),
    alignItems: 'center',
    minWidth: spacing(286),
  },
  helpButton: {
    alignSelf: 'end',
    marginBottom: spacing(-2),
  },
}))
